import { Rive } from '@rive-app/canvas';

export const canvas = document.createElement('canvas');
canvas.classList.add('card__cart-icon');
canvas.width = 100;
canvas.height = 100;

new Rive({
	src: '/assets/animations/cart.riv',
	canvas,
	autoplay: true,
	stateMachines: 'bag',
});
